import React from "react";
import { IMAGES } from "@/lib/content";

export const PageBanner = ({ title, subtitle, image = IMAGES.aboutPort, eyebrow }) => {
  return (
    <section
      className="relative isolate overflow-hidden"
      style={{ backgroundImage: `url(${image})`, backgroundSize: "cover", backgroundPosition: "center" }}
      data-testid="page-banner"
    >
      {/* Dark green overlay for readable text */}
      <div className="absolute inset-0 bg-abayle-green-darker/75" />
      <div className="absolute inset-0 bg-gradient-to-b from-abayle-green-darker/40 via-abayle-green/55 to-abayle-green-dark/85" />

      <div className="relative container-abayle py-16 sm:py-20 lg:py-32 text-white">
        {eyebrow && (
          <div className="mb-4 inline-flex items-center gap-3">
            <span className="h-px w-8 sm:w-10 bg-abayle-gold" />
            <span className="text-abayle-gold uppercase text-[10px] sm:text-xs tracking-[0.25em] sm:tracking-[0.3em] font-semibold">
              {eyebrow}
            </span>
          </div>
        )}
        <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold tracking-tight max-w-4xl leading-[1.1] lg:leading-[1.05]" data-testid="banner-title">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-5 sm:mt-6 text-white/85 max-w-2xl text-sm sm:text-base lg:text-lg leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>

      {/* Thin gold bottom accent */}
      <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-abayle-gold" />
    </section>
  );
};

export default PageBanner;
